// DO NOT modify this file manually!
// This is file is updated at release time.

export const WIZARD_VERSION = '4.2.0';
